import type { PriorityExecutor } from '@lc/librunner'
import { createContext } from 'react'

export const ExecutorContext = createContext<PriorityExecutor | null>(null)
ExecutorContext.displayName = 'ExecutorContext'
